import * as sse_composeMessage from '../api/sse/composeMessage';
import * as sse_documentRequest from '../api/sse/documentRequest';
import { MenuItem } from '../common/components/side-menu/SideMenu';
import { menuItem } from '../utils/constants';
import * as gtr_webhook from '../webhook/gtrWebhooks';
import * as sig_webhook from '../webhook/sigWebhooks';
import * as sse_Drl from '../webhook/sseWebhooks';
import * as sso_webhook from '../webhook/ssoWebhooks';
import * as ssr_webhook from '../webhook/ssrWebhooks';
import { getContent as getSuiteWebhookContent } from '../webhook/suiteWebhooks';
import * as sig_archivedReport from './sig/archived';
import * as sig_deliveredReport from './sig/delivered';
import * as sig_draftReport from './sig/draftReport';
import * as sig_recycleBin from './sig/recycleBin';
import * as sig_status from './sig/status';
import * as sig_upload from './sig/upload';
import * as sse_documentRequestTemplate from './sse/documentRequestTemplate';
import * as sso_archived from './sso/archived';
import * as sso_delivered from './sso/delivered';
import * as sso_inProcess from './sso/inProcess';
import * as sso_organizerStatus from './sso/organizerStatus';
import * as sso_recycleBin from './sso/recycleBin';
import * as sso_upload from './sso/upload';
import * as sso_uploads from './sso/upload';
import * as ssr_archived from './ssr/archived';
import * as ssr_delivered from './ssr/delivered';
import * as ssr_inProcess from './ssr/inProcessReturn';
import * as ssr_recycleBin from './ssr/recycleBin';
import * as ssr_returns from './ssr/returns';
import * as ssr_returnStatus from './ssr/returnsStatus';
import * as suite_clientManagement from './suite/clientManagement';
import * as suite_officeLocation from './suite/officeLocation';
import * as suite_userManagement from './suite/userManagement';
import * as loginAPI from './login/login';
import * as gtr_delivered from './gtr/delivered';
import * as gtr_inProcess from './gtr/inProcess';

export const getContent = (menu: MenuItem) => {
    const apiGroup = menu?.path ? menu.path.split('/')[2] : '';
    const apiName = menu.title.split(' ').slice(1).join(' ');
    const productName = menu?.path ? menu.path.split('/')[1] : '';
    const webhookName = menu.title;

    switch (apiGroup ? apiGroup : productName) {
        case 'Login':
            return loginAPI.getContent(apiName);
        case 'In Process':
            return ssr_inProcess.getContent(apiName);
        case 'Archived':
            return ssr_archived.getContent(apiName);
        case 'Delivered':
            return ssr_delivered.getContent(apiName);
        case 'Recycle Bin':
            return ssr_recycleBin.getContent(apiName);
        case 'Returns':
            return ssr_returns.getContent(apiName);
        case 'Return Status':
            return ssr_returnStatus.getContent(apiName);
        case 'Upload':
            return sso_uploads.getContent(apiName);
        case 'Archived Organizer':
            return sso_archived.getContent(apiName);
        case 'Delivered Organizer':
            return sso_delivered.getContent(apiName);
        case 'Organizer Status':
            return sso_organizerStatus.getContent(apiName);
        case 'Recycle Bin Report':
            return sig_recycleBin.getContent(apiName);
        case 'Draft Report':
            return sig_draftReport.getContent(apiName);
        case 'Delivered Report':
            return sig_deliveredReport.getContent(apiName);
        case 'Archive Report':
            return sig_archivedReport.getContent(apiName);
        case 'Signature Upload':
            return sig_upload.getContent(apiName);
        case 'Status':
            return sig_status.getContent(apiName);
        case 'In Process Organizer':
            return sso_inProcess.getContent(apiName);
        case 'Recycled Organizer':
            return sso_recycleBin.getContent(apiName);
        case 'Upload Organizer':
            return sso_upload.getContent(apiName);
        case 'Delivered Gather':
            return gtr_delivered.getContent(apiName);
        case 'In Process Gather':
            return gtr_inProcess.getContent(apiName);
        case 'Compose Message':
            return sse_composeMessage.getContent(apiName);
        case 'Document Request':
            return sse_documentRequest.getContent(apiName);
        case 'Document Request Template':
            return sse_documentRequestTemplate.getContent(apiName);
        case 'Client Management':
            return getClientManagement(webhookName, apiName);
        case 'Office Location':
            return suite_officeLocation.getContent(apiName);
        case 'User Management':
            return suite_userManagement.getContent(apiName);
        case 'SafeSend Exchange':
            return sse_Drl.getContent(webhookName);
        case 'SafeSend Returns':
            return ssr_webhook.getContent(webhookName);
        case 'SafeSend Signatures':
            return sig_webhook.getContent(webhookName);
        case 'SafeSend Organizers':
            return sso_webhook.getContent(webhookName);
        case 'SafeSend Gather':
            return gtr_webhook.getContent(webhookName);
    }
};

const getClientManagement = (webhookName: string, apiName: string) => {
    return menuItem.clientInformationChange == webhookName ?
        getSuiteWebhookContent(webhookName) :
        suite_clientManagement.getContent(apiName);
}
